import { ReactComponent as BlankLink } from 'assets/icons/Group 240018.svg';
import AlertDialog from "components/Dialog";
import MyModal from "components/MyModal";
import React, { useState } from 'react';
import { FormViwer } from './FormViwer';
import { ParentFormViewer } from "./ParentFormViewer";
import './ParticipantDrawer.scss';
import { Files } from './Theme';

const UserDetailsTabComponent = ({ participantInfo, afterUpdatedParticipantHandler }) => {
  const [viewForm, setViewForm] = useState();
  const [viewParentForm, setViewParentForm] = useState();
  const [confirmClose, setConfirmClose] = useState(false);

  const handleDownload = async (file) => {
    const link = document.createElement("a");
    link.href = file;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const formSchema = [
    { label: 'First Name', element: 'firstName', value: participantInfo?.firstName },
    { label: 'Last Name', element: 'lastName', value: participantInfo?.lastName },
    { label: 'Birth Date', element: 'dateOfBirth', value: participantInfo?.dateOfBirth },
  ];
  participantInfo?.formData && Object.entries(participantInfo?.formData).forEach(([key, value]) => {
    if (key?.split('_')[0] === 'checkboxes' || key?.split('_')[0] === 'radiobuttons') {
      formSchema.push({ label: value[0]?.label || value?.label || key?.split('_')[0], element: key?.split('_')[0], value });
    } else {
      formSchema.push({ label: key?.split('-')[0], element: key?.split('-')[0], value });
    }
  });

  const onUpdateFormParticipant = (values) => {
    setViewForm(false);
    setViewParentForm(false);
    afterUpdatedParticipantHandler(values);
  };

  const closeModal = () => setConfirmClose(true);

  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setViewForm(false);
    setViewParentForm(false);
  };


  return (
    <div>
      <div className="text-primary" role="button" onClick={() => { setViewForm(!viewForm) }}>
        <BlankLink className="mr-2 mb-1" /> View Form Response
      </div>
      {participantInfo?.parentInfo?.length > 0 && (
        <div className="text-primary mt-3" role="button" onClick={() => { setViewParentForm((prev) => !prev) }}>
          <BlankLink className="mr-2 mb-1" /> View Parent Form Response
        </div>
      )}

      <hr />
      <div className="files__container">
        <div className="files__title">
          {`Files(${participantInfo?.files?.length})`}
        </div>
        <Files>
          {participantInfo?.files.map((file, index) => (
            <li onClick={() => { handleDownload(file) }}>file {index + 1}</li>
          ))}
        </Files>
      </div>
      <MyModal
        open={viewForm}
        className="view-form-modal"
        onClose={closeModal}
        PaperProps={{
          style: {
            minHeight: "80vh",
            maxHeight: "94vh",
            background: "#fff",
            borderRadius: "10px",
          },
        }}
      >
        <div style={{
          fontWeight: "700",
          display: "flex",
          fontSize: "20px",
          justifyContent: "center",
          color: "#002E5C",
          paddingTop: "15px",
          paddingBottom: "20px",
        }}>
          User Details
        </div>
        <FormViwer formData={participantInfo} formSchema={formSchema} handleDownload={handleDownload} participantId={participantInfo?._id}
          onUpdateFormParticipant={onUpdateFormParticipant} />
      </MyModal>
      <MyModal
        open={viewParentForm}
        className="view-form-modal"
        onClose={closeModal}
        PaperProps={{
          style: {
            minHeight: "80vh",
            maxHeight: "94vh",
            background: "#fff",
            borderRadius: "10px",
          },
        }}
      >
        <div style={{
          fontWeight: "700",
          display: "flex",
          fontSize: "20px",
          justifyContent: "center",
          color: "#002E5C",
          paddingTop: "15px",
          paddingBottom: "20px",
        }}>
          Parent Form Response
        </div>
        <ParentFormViewer
          formData={participantInfo}
          handleDownload={handleDownload}
          participantId={participantInfo?._id}
          onUpdateFormParticipant={onUpdateFormParticipant}
        />
      </MyModal>
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </div>
  );
};


export default UserDetailsTabComponent;
